module.exports = __webpack_public_path__ + "static/media/flag03.ebe82656.svg";